import Vue from "vue";
import VueCompositionApi, { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import { showSnackBar } from "@/composables/snackbar";

Vue.use(VueCompositionApi);

const editions = ref({});
const currentEdition = ref({});

export function useCardEdition() {
  const editionData = reactive({
    editedItem: null,
    cardEditionFormRef: null,
    cardEditionForm: {},
    affectClientCardForm: {},
    affectClientCardFormRef: null,
    openCreateDialog: false,
    createCardEditionDialog: false,
    openEditDialog: false,
    openAffectDialog: false,
    isLoading: false,
    fetchingEdition: false,
    options: {},
    restrictionTypesChoice: [
      { text: "Portail seulement", value: 1 },
      { text: "Portail et clients du même groupe", value: 2 },
      { text: "Aucune", value: 3 },
    ],
    rules: {
      partnerRules: [(v) => !!v || "Il faut selectionner un partenaire"],
      prefixRules: [
        (v) =>
          (!!v && v.length <= 4) ||
          "Le préfixe ne doit pas dépasser 4 caractères",
        (v) => !!v || "Le préfixe ne peut pas être vide",
      ],
      commentRules: [(v) => !!v || "Le commentaire ne peut pas être vide"],
      clientRules: [(v) => !!v || "Un client doit être sélectionner"],
    },
    stepOneError: false,
    stepTwoError: false,
  });

  function listCardEditions() {
    const params = new URLSearchParams();
    params.set("page", editionData.options.page ?? 1);
    params.set("itemsPerPage", editionData.options.itemsPerPage ?? 100);

    if (editionData.options.sortBy && editionData.options.sortBy.length > 0) {
      if (editionData.options.sortDesc[0]) {
        params.set("order[desc]", editionData.options.sortBy[0]);
      } else {
        params.set("order[asc]", editionData.options.sortBy[0]);
      }
    }

    editionData.isLoading = true;
    return _axios
      .get("/list-edition?" + params.toString())
      .then((response) => {
        editions.value = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de la récupération des éditions de cartes. Si le problème persiste, veuillez contacter le support."
        );
      })
      .finally(() => {
        editionData.isLoading = false;
      });
  }

  function createCardEdition(payload) {
    editionData.isLoading = true;
    editionData.createCardEditionDialog = true;
    if (editionData.cardEditionFormRef != null) {
      const isValid = editionData.cardEditionFormRef.validate();
      if (!isValid || payload.cardModels.length < 1) {
        editionData.isLoading = false;
        editionData.stepOneError = true;
        if (payload.cardModels.length < 1) {
          editionData.stepTwoError = true;
        }
        alert(editionData.stepOneError);
        return;
      } else {
        editionData.stepOneError = false;
        editionData.stepTwoError = false;
      }
    }

    return _axios
      .post("/edition", payload)
      .then((response) => {
        console.log(response);
        showSnackBar();
        editionData.createCardEditionDialog = false;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de la création d'une édition de cartes. Si le problème persiste veuillez contacter le support"
        );
      })
      .finally(() => {
        editionData.isLoading = false;
      });
  }

  function affectClientCardEdition(payload) {
    editionData.isLoading = true;
    if (editionData.affectClientCardFormRef != null) {
      const isValid = editionData.affectClientCardFormRef.validate();
      if (!isValid) {
        editionData.isLoading = false;
        return;
      }
    }

    return _axios
      .post("/affect-card-client", payload)
      .then((response) => {
        console.log(response);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de l'affectation de de cartes à un nouveu client. Si le problème persiste veuillez contacter le support."
        );
      })
      .finally(() => {
        editionData.isLoading = false;
      });
  }

  function fetchCardEdition(id) {
    editionData.fetchingEdition = true;
    return _axios
      .get(`/edition/${id}`)
      .then((response) => {
        currentEdition.value = response.data.data;
        editionData.fetchingEdition = false;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de la récupération de l'édition #" +
            id +
            ". Si le problème persiste veuillez contacter le support."
        );
      });
  }

  function deleteCardEdition() {
    return _axios
      .delete(`/edition/${currentEdition.value.id}`)
      .then(() => {
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de la suppression d'une édition de cartes. Si le problème persiste veuillez contacter le support"
        );
      });
  }

  function exportEdition(id) {
    return _axios
      .get(`/edition/${id}/export`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        createAndDestroyDownloadElement(response.data, id);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de l'export d'une édition de cartes. Si le problème persiste veuillez contacter le support"
        );
      });
  }

  function createAndDestroyDownloadElement(stream, editionId) {
    const container = document.getElementById("csvLinkContainer");
    if (container) {
      const shadowLink = document.createElement("a");
      //const buf = new ArrayBuffer(stream.length);
      //const view = new Uint8Array(buf);
      //for (let i=0; i<stream.length; i++) view[i] = stream.charCodeAt(i) & 0xFF;
      console.log(stream);
      const blob = new Blob([stream], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);
      container.appendChild(shadowLink);
      shadowLink.setAttribute("href", url);
      shadowLink.setAttribute("download", `Edition_${editionId}.xlsx`);
      shadowLink.click();
      container.removeChild(shadowLink);
    }
  }

  function fetchEditionListCards() {
    editionData.isLoading = true;
    const params = new URLSearchParams();
    params.set("page", editionData.options.page ?? 1);
    params.set("itemsPerPage", editionData.options.itemsPerPage ?? 100);

    if (editionData.options.sortBy && editionData.options.sortBy.length > 0) {
      if (editionData.options.sortDesc[0]) {
        params.set("order[desc]", editionData.options.sortBy[0]);
      } else {
        params.set("order[asc]", editionData.options.sortBy[0]);
      }
    }

    return _axios
      .get(`/list-card/edition/${currentEdition.value.id}?${params.toString()}`)
      .then((response) => {
        currentEdition.value.cards = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue lors de la suppression d'une édition de cartes. Si le problème persiste veuillez contacter le support"
        );
      })
      .finally(() => {
        editionData.isLoading = false;
      });
  }

  return {
    editions,
    editionData,
    listCardEditions,
    createCardEdition,
    affectClientCardEdition,
    currentEdition,
    fetchCardEdition,
    deleteCardEdition,
    exportEdition,
    fetchEditionListCards,
  };
}
